// @ts-expect-error
import NimbleEmoji from 'emoji-mart/dist/components/emoji/nimble-emoji';

export { NimbleEmoji as default };
